import { Controller } from "@hotwired/stimulus"

// Handles filter frame lifecycle hooks.
// Keeps a minimal non-blocking loading indicator (no dim/overlay).
export default class extends Controller {
  static targets = ["frame"]

  connect() {
    this.boundShowLoading = this.showLoading.bind(this)
    this.boundHideLoading = this.hideLoading.bind(this)

    if (this.hasFrameTarget) {
      this.frameTarget.addEventListener("turbo:before-fetch-request", this.boundShowLoading)
      this.frameTarget.addEventListener("devfound:filter-loading-start", this.boundShowLoading)
      this.frameTarget.addEventListener("turbo:frame-load", this.boundHideLoading)
      this.frameTarget.addEventListener("turbo:fetch-request-error", this.boundHideLoading)
    }
  }

  disconnect() {
    if (this.hasFrameTarget) {
      this.frameTarget.removeEventListener("turbo:before-fetch-request", this.boundShowLoading)
      this.frameTarget.removeEventListener("devfound:filter-loading-start", this.boundShowLoading)
      this.frameTarget.removeEventListener("turbo:frame-load", this.boundHideLoading)
      this.frameTarget.removeEventListener("turbo:fetch-request-error", this.boundHideLoading)
    }

    this.removeLoadingIndicator()
  }

  showLoading() {
    if (this.hasFrameTarget) {
      this.frameTarget.classList.add("turbo-frame-loading")
    }
    this.createLoadingIndicator()
  }

  hideLoading() {
    if (this.hasFrameTarget) {
      this.frameTarget.classList.remove("turbo-frame-loading")
    }

    this.removeLoadingIndicator()
  }

  createLoadingIndicator() {
    if (!this.hasFrameTarget) return
    this.removeLoadingIndicator()

    const indicator = document.createElement("div")
    indicator.id = "filter-loading-indicator"
    indicator.className = "filter-loading-indicator"
    indicator.innerHTML = `<div class="filter-loading-ring" role="status" aria-label="Loading jobs"></div>`

    this.frameTarget.appendChild(indicator)
  }

  removeLoadingIndicator() {
    document.getElementById("filter-loading-overlay")?.remove()
    document.getElementById("filter-loading-indicator")?.remove()
  }
}
